import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';

import { environment } from '../../../environments/environment'
import { CommonService } from './common.service';


@Injectable({
  providedIn: 'root'
})
export class PageService {

  constructor(private http: HttpClient, private commonService: CommonService) { }

  options = { headers: new HttpHeaders ({ 'Content-Type': 'application/json' }) }

  getHomeContent(startCount: number, region: string): Observable<any> {
    let lang;
    if(lang == 'od') {
      lang = 'od'
    }
    else {
      lang = ''
    }
    // return this.http.get<any>(environment.apiURL+"catalog_lists/home-list?region=IN&item_language="+lang+"&auth_token="+environment.authtoken)
    // return this.http.get<any>('http://216.48.179.109/catalog_lists/home?auth_token=jqeGWxRKK7FK5zEk3xCM')
    // http://13.235.99.58:3001/catalog_lists/home-list?region=IN&item_language=&auth_token=3zZmzoHg8z6SM3wpDoyw
    //return this.http.get<any>(environment.apiURL+"catalog_lists/home.gzip?region="+region+"&item_language="+lang+"&page=0&page_size=0&start_count="+startCount+"&auth_token="+environment.authtoken+"&pagination=true")
    return this.http.get<any>(environment.apiURL+"catalog_lists/home-list?region="+region+"&item_language="+lang+"&page=0&page_size=0&start_count="+startCount+"&auth_token="+environment.authtoken+"&pagination=true")

    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }

  isItemsCatalog(catalogName: string): boolean {
    return catalogName === 'tarangaplus-originals';
  }

  getCatloagContent(startCount: number,catlogName: string, lang: string, region: string): Observable<any> {
    if (this.isItemsCatalog(catlogName)) {
      if (startCount > 0) {
        return of({ data: { catalog_list_items: [] } });
      }
      return this.http.get<any>(environment.apiURL+"catalogs/"+catlogName+"/items.gzip?region="+region+"&page=0&page_size=100&start_count="+startCount+"&auth_token="+environment.authtoken+"&pagination=true")
      .pipe(
        retry(1),
        map((resp) => this.normalizeCatalogItemsToList(resp, catlogName)),
        catchError(this.commonService.handleError)
       );
    }
    return this.http.get<any>(environment.apiURL+"catalog_lists/"+catlogName+".gzip?region="+region+"&page=0&page_size=0&start_count="+startCount+"&auth_token="+environment.authtoken+"&pagination=true")
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }

  private normalizeCatalogItemsToList(resp: any, catalogName: string) {
    const data = resp?.data || {};
    const items = (data.items || []).map((item) => {
      if (!item.catalog_object) {
        item.catalog_object = { friendly_id: catalogName };
      } else if (!item.catalog_object.friendly_id) {
        item.catalog_object.friendly_id = catalogName;
      }
      return item;
    });
    const layout = data.catalog_object?.layout_scheme || 't_2_3_movie';
    const title = data.display_title || data.name || catalogName;
    return {
      ...resp,
      data: {
        ...data,
        display_title: title,
        layout_scheme: layout,
        catalog_list_items: [
          {
            layout_type: 't_16_9_banner',
            catalog_list_items: items.slice(0, Math.min(5, items.length)),
            display_title: title,
            title: title,
            home_link: catalogName
          },
          {
            layout_type: layout,
            catalog_list_items: items,
            display_title: title,
            title: title,
            home_link: catalogName,
            friendly_id: catalogName
          }
        ]
      }
    };
  }


  getserialEpisodes(region: string): Observable<any> {
    return this.http.get<any>(environment.apiURL+"catalog_lists/premium-serials-episodes?region="+region+"&page=0&page_size=0&auth_token="+environment.authtoken+"&pagination=true")
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }


  getStarDetails(castId:string): Observable<any> {
    // {{ott_2.0_url}}/starcast_search/642c2db41e7171c473fb8583?&region=any&item_language=&auth_token=eKJTE4SSzAyKq3wdTCZ9
    return this.http.get<any>(environment.apiURL+"starcast_search/"+castId+"?&region=any&item_language=&auth_token="+environment.authtoken)
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }

  getLiveTVContent(lang: string, region: string): Observable<any> {
    if(lang == 'od') {
      lang = 'od'
    }
    else {
      lang = ''
    }
    return this.http.get<any>(environment.apiURL+"catalog_lists/popular-channels.gzip?page_size=150&region="+region+"&item_language="+lang+"&auth_token="+environment.authtoken)
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }

  getLiveTvContentDetails(catlogName: string, showName: string, region: string): Observable<any> {
    //http://13.212.17.223:3001/catalogs/all-channels/items/1-music/programs.gzip?region=IN&auth_token=Nkz7pAqnqSPizUfNY8rx
    return this.http.get<any>(environment.apiURL+"catalogs/"+catlogName+"/items/"+showName+"/programs.gzip?region="+region+"&auth_token="+environment.authtoken)
    // return this.http.get<any>(environment.apiURL+"catalogs/all-channel/items/"+catlogName+"/programs.gzip?region="+region+"&auth_token="+environment.authtoken)

    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }

  getLiveTvContentDetailsByTime(catlogName: string, region: string, date:string){
    http://216.48.179.109/catalogs/live-channel/items/live-channel-1/programs.gzip?region=IN&auth_token=jqeGWxRKK7FK5zEk3xCM&start_time=202303310930

    return this.http.get<any>(environment.apiURL+"catalogs/live-tv/items/"+catlogName+"/programs.gzip?region="+region+"&auth_token="+environment.authtoken+"&start_time="+date)
    // return this.http.get<any>(environment.apiURL+"catalog_lists/live-channel.gzip?region="+region+"&item_language=&auth_token="+environment.authtoken+"&pagination=true&start_date="+date+"&language="+languages+"&genres="+genres+"&start_count="+startCount+"&page_size=6")
    .pipe(
      catchError(this.commonService.handleError)
    );
  }

  getItemDetails(lang: string, catalog_slug: string, show_slug: string, region: string): Observable<any> {
    if(lang == 'od') {
      lang = 'od'
    }
    else {
      lang = ''
    }
    // console.log("catalog_slug"+catalog_slug+"show_slug"+catalog_slug);
    return this.http.get<any>(environment.apiURL+"catalogs/"+catalog_slug+"/items/"+show_slug+".gzip?&region="+region+"&item_language="+lang+"&auth_token="+environment.authtoken)
    //return this.http.get<any>('http://13.212.17.223:3001/catalogs/620a761a1f659b1f07f7181a/items/620a793b1f659b1f07f7181c.gzip?region=NG&item_language=&auth_token=Nkz7pAqnqSPizUfNY8rx&pagination=true')
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }

  
  getEpisodeDetails(lang: string, catalog_slug: string, show_slug: string, item_slug: string, region: string ): Observable<any> {
    if(lang == 'od') {
      lang = 'od'
    }
    else {
      lang = ''
    }
    
    return this.http.get<any>(environment.apiURL+"catalogs/shows/"+show_slug+"/episodes/"+item_slug+".gzip?&region="+region+"&item_language="+lang+"&auth_token="+environment.authtoken)
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }
  

  getAllEpisodes(lang: string, catalog_slug: string, show_slug: string, region: string, episode_order: string ): Observable<any> {
    if(lang == 'od') {
      lang = 'od'
    } 
    else {
      lang = ''
    }
    
    if (show_slug.includes('share_url=true')) {
    show_slug = show_slug.split('?')[0]; // keeps only "kokua"
  }
    return this.http.get<any>(environment.apiURL+"catalogs/"+catalog_slug+"/items/"+show_slug+"/episodes.gzip?order_by="+episode_order+"&region="+region+"&item_language="+lang+"&auth_token="+environment.authtoken+"&status=published")
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }

  getSeasonEpisodes(season: any,order:string, catalog_slug: any, show_slug: any, region:string): Observable<any> {

    return this.http.get<any>(environment.apiURL+"catalogs/"+catalog_slug+"/items/"+show_slug+ "/subcategories/" + season + "/episodes.gzip?order_by="+order+"&auth_token="+environment.authtoken+"&region="+region+"&status=published")
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }

  getEpisodesWithoutSeasons(catalog_slug: any, show_slug: any, region:string): Observable<any> {
    return this.http.get<any>(environment.apiURL+"catalogs/"+catalog_slug+"/items/"+show_slug + "/episode_list?page=0&page_size=500&order_by=desc&auth_token="+environment.authtoken+"&region="+region+"&item_language=en"+"&status=published")
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }

  // getCatalogDetails(lang: string, catalog_slug: string, region:string) {
  //   return this.http.get<any>(environment.apiURL+"catalogs/"+catalog_slug+"/items.gzip?region="+region+"&item_language="+lang+"&auth_token="+environment.authtoken)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }

  getRelatedItemsWithGenre(startCount: any, lang: string, catalog_slug: string, region:string, genres: any) {
    if(lang == null){
      return this.http.get<any>(environment.apiURL+"catalogs/"+catalog_slug+"/items.gzip?genres="+genres+"&region="+region+"&start_count="+startCount+"&pageSize="+20+"&item_language=null&auth_token="+environment.authtoken+"&status=published")
      .pipe(
        retry(1),
        catchError(this.commonService.handleError)
      );
    } else {
      return this.http.get<any>(environment.apiURL+"catalogs/"+catalog_slug+"/items.gzip?genres="+genres+"&region="+region+"&start_count="+startCount+"&pageSize="+20+"&auth_token="+environment.authtoken+"&languages="+lang+"&status=published")
      .pipe(
        retry(1),
        catchError(this.commonService.handleError)
      );
      }
  }

  // getItemGenre(lang: string, catalog_slug: string, genre: any, region: string) {
  //   return this.http.get<any>(environment.apiURL+"catalogs/"+catalog_slug+"/items.gzip?genre="+genre+"&region="+region+"&item_language="+lang+"&auth_token="+environment.authtoken)
  //   .pipe(
  //     retry(1),
  //     catchError(this.commonService.handleError)
  //    );
  // }
  getAssociatedVideos(lang: string, catalog_slug: string, item_slug: any, region: string) {
    return this.http.get<any>(environment.apiURL+"catalogs/"+catalog_slug+"/items/"+item_slug+"videolists.gzip?region="+region+"&item_language="+lang+"&auth_token="+environment.authtoken)
    .pipe(
      retry(1),
      catchError(this.commonService.handleError)
     );
  }

  getSharaParameters(region: string, obj: any) {
    // https://apiprod.9tv.com.ng/users/get_share_parameters.gzip?auth_token=tgvnPAkwwbLhW8JszqB2&region=NG&item_language=en
    return this.http.post<any>(environment.apiURL+"users/get_share_parameters.gzip?&auth_token="+environment.authtoken+"&region="+region+"&item_language=en", JSON.stringify(obj), this.options)
    .pipe(
      // retry(1),
      catchError(this.commonService.handleError)
    );
  }

  getNextEpisode(catalog_slug: string, show_slug: string, item_slug: string, region: string){
    // return this.http.get<any>(environment.apiURL+"catalog/"+catalog_slug+"/show/"+show_slug+"/episode/"+item_slug+"/next_item.gzip?auth_token="+environment.authtoken+"&region="+region)
    return this.http.get<any>(environment.apiURL+"catalogs/"+catalog_slug+"/items/"+show_slug + "/episode_list?page=0&page_size=500&order_by=desc&auth_token="+environment.authtoken+"&region="+region+"&status=published")
    .pipe(
      catchError(this.commonService.handleError)
     );
  }

}
